import { createContext, useContext } from "react"

type RouteContextData = {
  prevRouteName: string
  curRouteName: string
}

export const RouteContext = createContext<RouteContextData>({
  prevRouteName: "",
  curRouteName: "",
})

export const useRouteContext = () => useContext(RouteContext)
